module.exports = __webpack_public_path__ + "img/grand-palm-hotel-4.11a42105.jpg";